
const digest = '88516c300a23d0e3a7a81548013fd3dd08b6a0440888ff52374c27367ea154ad';
const classes = {"wrapper":"_wrapper_1wgta_1","innerWrapper":"_innerWrapper_1wgta_11","imageWrapper":"_imageWrapper_1wgta_15","content":"_content_1wgta_25","title":"_title_1wgta_29","subtitle":"_subtitle_1wgta_34"};
const css = `._wrapper_1wgta_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 13px 14px;
  display: flex;
  flex-direction: row;
  text-decoration: none;
  box-shadow: -3px 7px 13px 0 rgba(68, 70, 105, 0.15);
  margin-top: 1rem;
}
._wrapper_1wgta_1 ._innerWrapper_1wgta_11 {
  display: flex;
  flex-grow: 1;
}
._wrapper_1wgta_1 ._imageWrapper_1wgta_15 {
  position: relative;
  margin-right: 14px;
}
._wrapper_1wgta_1 ._imageWrapper_1wgta_15 img {
  height: 50px;
  width: 50px;
  border-radius: 100%;
  object-fit: cover;
}
._wrapper_1wgta_1 ._content_1wgta_25 {
  padding-top: 5px;
  flex-grow: 1;
}
._wrapper_1wgta_1 ._content_1wgta_25 ._title_1wgta_29 {
  color: #3c3f9c;
  font-size: 14px;
  font-weight: 600;
}
._wrapper_1wgta_1 ._content_1wgta_25 ._subtitle_1wgta_34 {
  color: #212357;
  font-size: 12px;
  font-weight: 400;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  